import React, { useState, useRef, useEffect, useContext} from 'react';
import { IProps, IListProps } from './types';
import * as S from './styles';
import { default as D } from '@assets/themes/dimensions';
import { IDSConfig, IBrandImageFilter, IBrandDefinition, IBrandImageType } from '@state/dsconfig/types';
import { IOemFilter, IType} from '@state/brandsImages/types';
import { useSelector } from 'react-redux';
import selectors from '@state/selectors';
import { IBrandImageSection } from '@utils/DOIgnition/BrandsContext';
import { FilterIcon } from '@assets/icons/filterIcon';
import FilterCheck from '@components/Filter';
import { flatten, isEqual } from 'lodash';
import ClickOutside from '@components/ClickOutside';
import { getListVehicles, vehicleFilterstoShow, getListLogos } from '@utils/brand'
import { AuthContext } from '@utils/DOIgnition/AuthContext';
import { IUserAccessBrand } from '@state/userAccess/types';

let marginLeft = "auto";
let width= `fit-content`;

const CustomList:React.FC<IListProps> = (props) => {
  const empyState = useRef<boolean>(true);
  const added = useRef<string[]>([]);

  useEffect(() => {
    if (empyState) empyState.current=true;
  }, [props.options]);

  const showHideFilter = (id: string, value: string) => {
    if (props.notHide) {
      if (added.current.find((valueAdded: string) => (valueAdded===value))) return false;
    }
    let found=false;
    props.typesFiltersShow?.map((filter: IType ) => {
      if (filter.id===id && filter.value===value) found=true;
    });
    return found;
  }

  const getList = (type:IBrandImageType , parentName?: string) => {
    let hasItems=false;
    let list =type?.types?.map((typeInfo:IBrandImageType, index:number) => {
      if (showHideFilter(props.filter.filterType, typeInfo.value) || props.filter.filterType==='year' || props.filter.filterType==='model') {
        added.current.push( typeInfo.value);
        hasItems=true;
        empyState.current=false;
        return <FilterCheck 
          key={`opt${index}`}
          label={typeInfo.value} 
          type={props.filter.filterType} 
          onChange={(value:any, type:string, add:boolean)=> props.onSelect(add, props.filter.filterType, typeInfo.value , typeInfo.value, added?.current)}
          checked={props.selectedFilters.includes(typeInfo.value)}/>
      }
    });
    return <>
      {hasItems && <>
      {(parentName && hasItems) && <S.ParentLabel>{parentName}</S.ParentLabel>}
      {list}</>
      }
    </>;
  }
  
  if (added.current) added.current=[];
  
  return (
    <>
      <S.List>
        <S.Label>{props.filter.columnName}</S.Label>
        {props.types.map((type:IBrandImageType ) => 
          getList(type, props.filter.showTypeParent ? type.value:undefined)
        )}
        { (empyState.current) && 
          <S.EmptyContainer>
            <S.CText>
              <S.Text>Select {props.filter.filterType==='year' ? 'type' : props.filter.filterType==='model' ? 'year' : 'theme'} to </S.Text><S.Text>see options</S.Text>
            </S.CText>
          </S.EmptyContainer>}
      </S.List>
    </>
  );
}

const Filters: React.FC<IProps> = (props) => {
  const [showMenu, setShowMenu]= useState(false);
  const [oemList, setOemList]= useState<string[]>([]);
  const [typeList, setTypeList]= useState<IType[]>([]);

  const section = `${props.category}s` as IBrandImageSection;
  const dsConfig: IDSConfig = useSelector(selectors.dsConfig.getDSConfig);
  
  const filters = dsConfig.brandsConfig[section]?.filters ?? [];
  const typesConfig = (props.brandImagesFilters && props.brandImagesFilters[0] && props.brandImagesFilters[0]?.typesVehicles)
                    ? props.brandImagesFilters[0]?.typesVehicles 
                    : dsConfig.brandsConfig[section]?.types ?? [];

  const authContext = useContext(AuthContext);
  const userData = authContext && authContext.userData?authContext.userData.profile:undefined;
                  

  const componentRef = useRef(null);
  const listKeep = useRef<any>({column: "", list: []});

  useEffect(() => {
    reload();
  }, [props.brandImagesFilters, props.selectedFilters]);

  const reload = () => {
    let oemFilters : string[] = [];
    let typeFilters : IType[] = [];
    let oemSelected = props.selectedFilters.filter((filter: IType)=> filter.id==="oem");
    let typesSelected = props.selectedFilters.filter((filter: IType)=> filter.id!=="oem");    
    props.brandImagesFilters?.map((filter: IOemFilter) => {
      if (typesSelected.length>0) {
        let search =false;
        if (oemSelected.find((itemAllow: IType) => filter.id=== itemAllow.value)) search=true;
        else {
          filter.types.forEach((item: IType) => {
              let searchItem = typesSelected.find((itemSelected: IType) =>  item.value===itemSelected.value)
              if (searchItem) search =true;
          });
        }
        if (search) oemFilters.push(filter.id);
      } else oemFilters.push(filter.id);

      if (oemSelected.length===0) if (filter.types) typeFilters = [...typeFilters, ...filter.types];
    });
    
    if (oemSelected.length>0) {
      oemSelected.forEach((oemSelected: IType) => {
          let searchItem = props.brandImagesFilters?.find((itemAllow: IOemFilter) =>  itemAllow.id===oemSelected.value);
          if (searchItem) typeFilters = [...typeFilters, ...searchItem.types];
      });

      typesSelected.forEach((typeSelected: IType) => {
        let searchItem = typeFilters?.find((itemAllow: IType) =>  itemAllow.value===typeSelected.value);
        if (searchItem===undefined) typeFilters = [...typeFilters, typeSelected];
      }); 
    }

    let typeOnly = props.selectedFilters.filter((filter: IType)=> filter.id==="type" || filter.id==="theme");
    if (typeOnly.length===0) typeFilters = typeFilters?.filter((filter: IType)=> filter.id!=="subtype" && filter.id!=="subtheme");
    else {
      let allsubTypes = flatten(typesConfig[0].types?.map((type:IBrandImageType) => {         
        if (props.selectedFilters.find((selectItem: IType)=> selectItem?.value===type?.value)) return type.types 
      }));
      let allsubThemes:(IBrandImageType|undefined)[] = [];
      if (props.category==="stock") {
        allsubThemes = flatten(typesConfig[1].types?.map((type:IBrandImageType) => { 
          if (props.selectedFilters.find((selectItem: IType)=> selectItem?.value===type?.value)) return type.types 
        }));
      }
      typeFilters = typeFilters?.filter((filter: IType)=> {
        filter.value = filter.value.replace("`","'");
        const foundSubType = allsubTypes.find((suItem: any)=> filter?.value===suItem?.value);
        const foundSubTheme = allsubThemes.find((suItem: any)=> filter?.value===suItem?.value);
        if ((filter.id==="subtype" && foundSubType) || (filter.id==="subtheme" && foundSubTheme)) {
          return filter;
        }
        else if (filter.id!=="subtype" && filter.id!=="subtheme") {
          return filter;
        }
      });
    }

    if (props.category==="vehicle") {
      typeFilters = vehicleFilterstoShow(props.selectedFilters, typesConfig[0]??[], typeFilters, listKeep?.current);
      if (props.onFilterShow) props.onFilterShow(typeFilters);
    }

    setOemList(oemFilters);
    setTypeList(typeFilters);
    

  }

  const handleClickBtnFilter = ()=>setShowMenu(!showMenu);

  const getOEMList = (columnName: string) => {
    if (props.notShowOem) return;
    return  <S.List>
              <S.Label>{userData.role==='DealerUser' ? 'Brands' : columnName}</S.Label>
              {dsConfig.brands.filter(oem => (props.allFilters.length>0 && oem.name==props.allFilters[0]) || !props.allFilters.length).sort((a, b) => {
                        var textA = a.name.toUpperCase();
                        var textB = b.name.toUpperCase();
                        return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
                      }).filter(b => b.id)
                        .map((text:IBrandDefinition, index:number) => {
                        if (oemList.includes(text.id)) {
                          return <FilterCheck 
                            key={`oem${index}`}
                            label={text.name} 
                            type="oem" 
                            onChange={(value:any, type:string, add:boolean)=> props.onSelect(add, "oem", text.id, text.name)}
                            checked={props.allFilters.includes(text.name)}
                            rootStyle={{display : text.useAsCommon?'none':'block'}}/>
                        }
                      }
              )}
            </S.List>
  }

  const getOptions = (id: string) => {
    if (id==="type") return flatten(typesConfig[0].types?.map((type:any) => { return type.value }).sort());
    else if (id==="subtype") {
      let subtypes: any[]= flatten(typesConfig[0].types?.map((type:any) => { return type.types }).sort());
      return flatten(subtypes.map((type:any) => { return type.value }).sort());
    }
    return [];
  }

  const selected : boolean = props.selectedFilters.length>0; 
  const getTypes =  (filter: IBrandImageFilter, id: string) => {
    if (props.category==="vehicle") return getListVehicles(typesConfig, id);
    else if (props.category==="logo" && (id ==='year' || id ==='model')) return getListLogos(props.brandImagesFilters??[], id, props.selectedFilters);
    return filter.showTypeParent 
            ?  props.category=="stock" 
                ? typesConfig[1].types:typesConfig[0].types 
            : typesConfig;
  }

  const getBackGround = () => {
    if (selected) return props.styleTransparent ? `rgba(255, 255, 255, 0.1)`:`rgba(32, 64, 120, 0.1)`; 
    else return props.styleTransparent ? 'transparent' : '#ffffff';;
  }

  return (
    <>
    <ClickOutside onClickOutside={()=> setShowMenu(false)}>
    <S.Root selected={selected} backgroundColor={getBackGround()}  transparent={props.styleTransparent}>
          <S.ButtonFilter style={props.buttonStyle} onClick={handleClickBtnFilter} id="filterButton" selected={selected} transparent={props.styleTransparent}>
              <FilterIcon fill={props.styleTransparent? '#FFF': selected ? '#204078' : undefined} style={{display: 'inline-block', verticalAlign: 'middle', marginLeft: "5px", marginRight: "14px"}}/>
              Filter
          </S.ButtonFilter>
    </S.Root >
    {filters.length>0 &&
      <S.MenuFilter ref={componentRef} margin={marginLeft} style={{
        display: showMenu?'flex':'none',
        width: props.width??width}}>
          {filters.map((filter: IBrandImageFilter, index:number) => {
            if (filter.filterType==="oem") return getOEMList(filter.columnName);
            else {
              return <CustomList
                        key={`list${index}`}
                        options={[]} 
                        filter={filter}
                        onSelect={(add: boolean, id: string, value: string, text:string, list?: string[]) => {
                          props.onSelect(add, id, value, text);
                          if (list && listKeep) {
                            listKeep.current.list = list;
                            listKeep.current.column = id;
                          }
                        }}
                        selectedFilters={props.allFilters}
                        typesFiltersShow={typeList}
                        types={getTypes(filter,filter.filterType )}
                        notHide={props.category=="vehicle"}
                        />;
                }
          })}
      </S.MenuFilter>
    }
    </ClickOutside>
  </>
  );
}

export default Filters;